// src/services/dietService.js
import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "../../utils/axiosBaseQuery"; // Assuming the same custom axiosBaseQuery is used
import {
  DIET_LIST,
  DIET_ADD,
  DIET_UPDATE,
  DIET_DELETE,
} from "../../config/constants"; // Adjust endpoints as per your config

const dietService = createApi({
  reducerPath: "dietService",
  baseQuery: axiosBaseQuery({ baseUrl: "" }), // Use axiosBaseQuery
  tagTypes: ["Diet"],
  endpoints: (builder) => ({
    getDiets: builder.query({
      query: (bodyData) => ({
        url: DIET_LIST, // Endpoint to fetch meal list
        method: "POST",
        data: bodyData, // Pass the body data for the request
      }),
      providesTags: ["Diet"],
    }),
    addDiet: builder.mutation({
      query: (mealData) => ({
        url: DIET_ADD, // Endpoint to add a meal
        method: "POST",
        data: mealData, // Diet data for the request body
      }),
      invalidatesTags: ["Diet"],
    }),
    updateDiet: builder.mutation({
      query: ({ mealId, updatedData }) => ({
        url: `${DIET_UPDATE}/${mealId}`, // Endpoint to update a meal
        method: "PUT",
        data: updatedData, // Updated meal data
      }),
      invalidatesTags: ["Diet"],
    }),
    deleteDiet: builder.mutation({
      query: (mealId) => ({
        url: `${DIET_DELETE}/${mealId}`, // Endpoint to delete a meal
        method: "DELETE",
      }),
      invalidatesTags: ["Diet"],
    }),
  }),
});

// Export hooks for usage in functional components
export const {
  useGetDietsQuery,
  useAddDietMutation,
  useUpdateDietMutation,
  useDeleteDietMutation,
} = dietService;

// Export the reducer to be included in the store
export default dietService;
